import { useSyncExternalStore } from 'react'

/**
 * Atualização do app instalado. O service worker é registrado no aviso de
 * atualização (raiz); aqui fica o que as telas precisam saber dele: a versão
 * em uso, se há uma versão nova baixando e como procurar uma agora.
 */

const versaoDoBuild = import.meta.env.VITE_APP_VERSION as string | undefined
/** Versão deste build (tag/commit do servidor; "dev" na máquina ou com o build-arg vazio). */
export const VERSAO_APP = versaoDoBuild?.trim() ? versaoDoBuild.trim() : 'dev'

interface Estado {
  registro: ServiceWorkerRegistration | null
  /** Uma versão nova está sendo baixada (o aviso de "pronta" vem em seguida). */
  baixando: boolean
}

let estado: Estado = { registro: null, baixando: false }
const ouvintes = new Set<() => void>()
const mudar = (parcial: Partial<Estado>) => {
  estado = { ...estado, ...parcial }
  for (const o of ouvintes) o()
}

/** Chamado uma vez, quando o service worker está registrado. */
export function acompanharRegistro(registro: ServiceWorkerRegistration) {
  mudar({ registro })
  registro.addEventListener('updatefound', () => {
    const novo = registro.installing
    // Primeira instalação (sem versão anterior controlando a página) não é atualização.
    if (!novo || !navigator.serviceWorker.controller) return
    mudar({ baixando: true })
    novo.addEventListener('statechange', () => {
      if (novo.state !== 'installing') mudar({ baixando: false })
    })
  })
}

export type ResultadoProcura = 'nova' | 'atual' | 'indisponivel'

/** Procura uma versão nova agora (toque na versão). */
export async function procurarAtualizacao(): Promise<ResultadoProcura> {
  const registro = estado.registro
  if (!registro) return 'indisponivel'
  await registro.update()
  return registro.installing || registro.waiting ? 'nova' : 'atual'
}

export function useAtualizacao(): Estado {
  return useSyncExternalStore(
    (o) => {
      ouvintes.add(o)
      return () => {
        ouvintes.delete(o)
      }
    },
    () => estado,
    () => estado,
  )
}
